import { render, staticRenderFns } from "./Histoire.vue?vue&type=template&id=522ce496&scoped=true&"
import script from "./Histoire.vue?vue&type=script&lang=js&"
export * from "./Histoire.vue?vue&type=script&lang=js&"
import style0 from "./Histoire.vue?vue&type=style&index=0&id=522ce496&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522ce496",
  null
  
)

export default component.exports